import { Dropdown, Grid, GridColumn, Input } from 'semantic-ui-react';

import { UserRole } from '~/constants/roles';

const ROLE_FILTER_OPTIONS = [
  { key: UserRole.ADMIN, text: 'Admin', value: UserRole.ADMIN },
  { key: UserRole.INVESTOR, text: 'Investor', value: UserRole.INVESTOR },
  { key: UserRole.INSTALLER, text: 'Developer', value: UserRole.INSTALLER },
  { key: UserRole.EXTERNAL, text: 'External', value: UserRole.EXTERNAL },
];

/** `null` = no filter (same as Role filter empty). */
export type AccountStatusFilter = 'active' | 'inactive' | null;

const ACCOUNT_STATUS_OPTIONS = [
  { key: 'active', text: 'Active', value: 'active' },
  { key: 'inactive', text: 'Deactivated', value: 'inactive' },
];

const colStyle = { padding: '1rem 0 0 1rem' };
const controlFontSize = { fontSize: '.9rem' };

interface UsersFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  companyName: string;
  onCompanyNameChange: (value: string) => void;
  roles: string[];
  onRolesChange: (value: string[]) => void;
  accountStatus: AccountStatusFilter;
  onAccountStatusChange: (value: AccountStatusFilter) => void;
}

export default function UsersFilters({
  search,
  onSearchChange,
  companyName,
  onCompanyNameChange,
  roles,
  onRolesChange,
  accountStatus,
  onAccountStatusChange,
}: UsersFiltersProps) {
  return (
    <div style={{ margin: '1rem 0 2rem', paddingRight: '1rem' }}>
      <Grid stackable>
        <GridColumn mobile={16} tablet={6} computer={3} style={colStyle}>
          <Input
            type='text'
            placeholder='Name or email…'
            value={search}
            onChange={e => onSearchChange(e.target.value)}
            fluid
            style={controlFontSize}
          />
        </GridColumn>
        <GridColumn mobile={16} tablet={6} computer={3} style={colStyle}>
          <Input
            type='text'
            placeholder='Company…'
            value={companyName}
            onChange={e => onCompanyNameChange(e.target.value)}
            fluid
            style={controlFontSize}
          />
        </GridColumn>
        <GridColumn mobile={16} tablet={6} computer={3} style={colStyle}>
          <Dropdown
            placeholder='Role…'
            fluid
            multiple
            search
            selection
            clearable
            options={ROLE_FILTER_OPTIONS}
            value={roles}
            onChange={(_, { value }) => onRolesChange(value as string[])}
            style={controlFontSize}
            selectOnBlur={false}
          />
        </GridColumn>
        <GridColumn mobile={16} tablet={6} computer={2} style={colStyle}>
          <Dropdown
            placeholder='Status…'
            fluid
            selection
            clearable
            options={ACCOUNT_STATUS_OPTIONS}
            value={accountStatus ?? undefined}
            onChange={(_, { value }) =>
              onAccountStatusChange((value as 'active' | 'inactive' | undefined) ?? null)
            }
            style={controlFontSize}
            selectOnBlur={false}
          />
        </GridColumn>
      </Grid>
    </div>
  );
}
